// react-bootstrap components
import { Card, Container, Row, Col } from "react-bootstrap";

import { Table } from "semantic-ui-react";

const AdminList = ({ data }) => {

  return (
    <Container fluid className="mt-20">
      <Row>
        <Col lg="12">
          <Card className="card-stats">
            <Card.Header>
              <Card.Title as="h1">Essilor Admin list</Card.Title>
            </Card.Header>
            <Card.Body>
              <Table celled>
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell>First Name</Table.HeaderCell>
                    <Table.HeaderCell>Last Name</Table.HeaderCell>
                    <Table.HeaderCell>Email</Table.HeaderCell>
                    <Table.HeaderCell>Practice Name</Table.HeaderCell>
                    <Table.HeaderCell>Area of Expertise</Table.HeaderCell>
                    <Table.HeaderCell>Enabled</Table.HeaderCell>
                  </Table.Row>
                </Table.Header>

                <Table.Body>
                  {data.map((d, i) => (
                    <Table.Row key={i}>
                      <Table.Cell>{d.firstName}</Table.Cell>
                      <Table.Cell>{d.lastName}</Table.Cell>
                      <Table.Cell>{d.email}</Table.Cell>
                      <Table.Cell>{d.practiceName}</Table.Cell>
                      <Table.Cell>{d.areaOfExpertise}</Table.Cell>
                      <Table.Cell>
                        <div className="mini ui buttons">
                          <button disabled={d.enabled} className="ui button positive">Enable</button>
                          <div className="or"></div>
                          <button disabled={!d.enabled} className="ui button red">Disable</button>
                        </div>
                      </Table.Cell>
                    </Table.Row>
                  ))}
                </Table.Body>
              </Table>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default AdminList;
